const FadeAndRemove = function (elm) {
  return new Promise(resolve => {
    const fadeEffect = setInterval(() => {
      if (!elm.style.opacity) {
        elm.style.opacity = 1
      }

      elm.style.opacity -= 0.1
      if (elm.style.opacity <= 0) {
        clearInterval(fadeEffect)
        elm.remove()
        resolve(true)
      }
    }, 30)
  })
};


export default FadeAndRemove;